/*
 * Copyright (c) 2023 Bolmate B.V.
 */
import './style/systemServices.scss';

import React, {MouseEventHandler, useMemo} from 'react';
import SystemService from "../../../models/systemServiceModel";
import {ChangeFunction, Loader} from '@dvrd/dvr-controls';
import {BolmateButton} from "../../controls";
import BolmateSwitch from "../../controls/switch/bolmateSwitch";

interface Props {
    onToggleService: (service: SystemService) => ChangeFunction;
    onToggleAll: MouseEventHandler;
    services: Array<SystemService>;
    loading: boolean;
    someActive: boolean;
}

export default function SystemServices(props: Props) {
    const {someActive, services, onToggleService, onToggleAll, loading} = props;
    const toggleLabel = useMemo(() => {
        if (someActive) return 'Alles uitschakelen';
        return 'Alles inschakelen';
    }, [someActive]);

    function onClickBack() {
        history.back();
    }

    function getServiceAction(service: SystemService): string {
        const action = service.active ? 'ingeschakeld' : 'uitgeschakeld';
        const format = 'DD-MM-YYYY HH:mm';
        const date = service.updatedAtMoment?.format(format) ?? service.createdAtMoment.format(format);
        return `(${action} op ${date})`;
    }

    function renderService(service: SystemService) {
        return (
            <div key={service.id} className='service'>
                <BolmateSwitch value={service.active} onChange={onToggleService(service)} disabled={loading}/>
                <label>{service.translatedName}</label>
                <label className='updated'>{getServiceAction(service)}</label>
            </div>
        )
    }

    return (
        <div className='system-services'>
            <div className='btns-container'>
                <BolmateButton onClick={onClickBack} label='Terug' disabled={loading}/>
                <BolmateButton onClick={onToggleAll} label={toggleLabel} disabled={loading} secondary/>
            </div>
            <div className='services-container'>
                <Loader active={loading}/>
                {services.map(renderService)}
            </div>
        </div>
    );
}